import React, { useState } from 'react';
import {
  Descriptions,
  Table,
  Modal,
  Button,
  Result,
  Spin,
  Typography,
  Space,
  Row,
  Col,
  Image,
} from 'antd';
import get from 'lodash/get';
import map from 'lodash/map';
import omit from 'lodash/omit';
import assign from 'lodash/assign';
import isNull from 'lodash/isNull';
import omitBy from 'lodash/omitBy';
import { useDispatch } from 'react-redux';
import { ArrowLeftOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { PRODUCT_CATALOGUE } from '../../../constants/routes';
import { productMangement } from '../../../redux/actions/productAction';

const { Column, ColumnGroup } = Table;
const { Text } = Typography;

const ProductFinalDetails = ({
  details,
  onMove,
  edit,
  productId,
  companyId,
}) => {
  const [loading, setLoading] = useState(false);

  const [videoPreview, setVideoPreview] = useState({
    visible: false,
    filePath: null,
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const onClickGoToCataLogue = () => {
    history.replace(PRODUCT_CATALOGUE);
  };

  const [successModal, setSuccessModal] = useState({
    visible: false,
    sku: null,
  });

  const toggleVideoPreview = (filePath = null) => {
    setVideoPreview({
      visible: !get(videoPreview, 'visible'),
      filePath,
    });
  };

  const onCreateProduct = (payload) => {
    setLoading(true);
    dispatch(productMangement('create.product', payload))
      .then((result) => {
        setLoading(false);
        setSuccessModal({
          visible: true,
          data: get(result, 'data'),
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onEditProduct = (payload) => {
    setLoading(true);
    dispatch(productMangement('update.product', payload))
      .then((result) => {
        setLoading(false);
        setSuccessModal({
          visible: true,
          data: get(result, 'data'),
        });
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onSubmit = () => {
    const payload = {
      is_active: true,
      company_id: companyId,
      ...get(details, 'step1'),
      ...get(details, 'step2'),
      ...get(details, 'step3'),
      ...get(details, 'step4'),
      product_resource: get(details, 'step1.media', []),
    };
    omit(payload, ['meta']);

    if (edit) {
      onEditProduct(
        assign(omit(omitBy(payload, isNull), ['meta', 'media']), {
          id: parseInt(productId),
          other_info: get(payload, 'other_info')
            ? get(payload, 'other_info')
            : '',
        })
      );
    } else {
      onCreateProduct(omit(omitBy(payload, isNull), ['meta']));
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="product-final-confirmation-container">
        <p className="normal-heading ">Product Details </p>
        <div className="product-description-container">
          <Descriptions bordered column={4} layout="vertical" size="small">
            <Descriptions.Item label="Product Type">
              {get(details, 'step1.is_sample') ? 'Sample' : 'Retail'}
            </Descriptions.Item>
            <Descriptions.Item label="Main Category">
              {get(details, 'step1.meta.category_1.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Sub Category">
              {get(details, 'step1.meta.category_2.name')}
            </Descriptions.Item>

            {get(details, 'step1.meta.category_3') && (
              <Descriptions.Item label="Sub-Sub Category">
                {get(details, 'step1.meta.category_3.name')}
              </Descriptions.Item>
            )}
            {get(details, 'step1.meta.category_4') && (
              <Descriptions.Item label="Sub-Sub-Sub Category">
                {get(details, 'step1.meta.category_4.name')}
              </Descriptions.Item>
            )}
            <Descriptions.Item label="Product Name">
              {get(details, 'step1.name')}
            </Descriptions.Item>
            <Descriptions.Item label="SKU Code">
              {get(details, 'step1.sku')}
            </Descriptions.Item>
            <Descriptions.Item label="GS1Code">
              {get(details, 'step1.gs1')}
            </Descriptions.Item>
          </Descriptions>
        </div>
        {get(details, 'step1.media', []).length > 0 && (
          <>
            <div className="mt-40">
              <p className="normal-heading ">Media </p>
            </div>
            <div className="media-section">
              {map(get(details, 'step1.media'), (m, index) => {
                if (get(m, 'type') === 1) {
                  return (
                    <Image
                      key={index}
                      src={get(m, 'file_path')}
                      className="img-upload-btn"
                      style={{
                        border: ' 1px dashed #d9d9d9',
                      }}
                    />
                  );
                }

                return (
                  <div className="img-upload-btn">
                    <PlayCircleOutlined
                      className="table-icon"
                      onClick={() => {
                        toggleVideoPreview(get(m, 'file_path'));
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}

        <div className="mt-40">
          <p className="normal-heading ">Other Details </p>
        </div>
        <div className="product-description-container ">
          <Descriptions bordered column={4} layout="vertical" size="small">
            <Descriptions.Item label="Brand Name">
              {get(details, 'step2.brand_name')}
            </Descriptions.Item>
            <Descriptions.Item label="MRP/Unit">
              {get(details, 'step2.mrp')}
            </Descriptions.Item>
            <Descriptions.Item label="Manufacture By">
              {get(details, 'step2.manufacturer_name')}
            </Descriptions.Item>

            <Descriptions.Item label="GST-cess">
              {get(details, 'step2.gst_cess')}
            </Descriptions.Item>
            <Descriptions.Item label="GST Slab">
              {get(details, 'step2.meta.gst_slab.name')}
            </Descriptions.Item>
            <Descriptions.Item label="HSN code">
              {get(details, 'step2.hsn_code')}
            </Descriptions.Item>
            <Descriptions.Item label="Product Storage Instruction">
              {get(details, 'step2.storage_instructions')}
            </Descriptions.Item>
          </Descriptions>
        </div>

        {get(details, 'step2.product_ingredient', []).length > 0 && (
          <>
            <div className="mt-40">
              <p className="normal-heading ">Product Ingredients </p>
            </div>
            <div className="product-description-container ">
              <Table
                bordered
                size="small"
                pagination={false}
                dataSource={get(details, 'step2.product_ingredient', [])}
                columns={[
                  {
                    title: 'Sno.',
                    key: 'Sno',
                    render: (t, record, index) => `${index + 1}`,
                  },
                  {
                    title: 'Description',
                    key: 'name',
                    dataIndex: 'name',
                  },
                  {
                    title: 'Amount',
                    key: 'name',
                    render: (t, record) =>
                      `${get(record, 'amount')} ${get(record, 'unit')}`,
                  },
                  {
                    title: 'Percentage',
                    key: 'percentage',
                    render: (t, record) => `${get(record, 'percentage')}%`,
                  },
                ]}
              />
            </div>
          </>
        )}
        {get(details, 'step2.product_nutrition', []).length > 0 && (
          <>
            <div className="mt-40">
              <p className="normal-heading ">Product Nutritions </p>
            </div>
            <div className="product-description-container ">
              <Table
                bordered
                size="small"
                pagination={false}
                dataSource={get(details, 'step2.product_nutrition', [])}
              >
                <ColumnGroup title="Nutritional Information per 100 gm">
                  <Column key="name" dataIndex="name" width="50%" />
                  <Column
                    key="value"
                    render={(t, record) => `${get(record, 'amount')}`}
                  />
                </ColumnGroup>
              </Table>
            </div>
          </>
        )}

        <div className="mt-40">
          <p className="normal-heading ">Additional Product Details </p>
        </div>
        <div className="product-description-container ">
          <Descriptions bordered column={4} layout="vertical" size="small">
            <Descriptions.Item label="Country of Origin">
              {get(details, 'step3.meta.country.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Shelf life">
              {get(details, 'step3.meta.shelf.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Color of product">
              {get(details, 'step3.color')}
            </Descriptions.Item>
            <Descriptions.Item label="Shape of product">
              {get(details, 'step3.meta.shape.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Flavour/Variant">
              {get(details, 'step3.flavour')}
            </Descriptions.Item>
            <Descriptions.Item label="Weight/Volume">
              {get(details, 'step3.weight_vol')}
            </Descriptions.Item>
            <Descriptions.Item label="Size of product">
              {get(details, 'step3.meta.size.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Packaging">
              {get(details, 'step3.meta.packaging.name')}
            </Descriptions.Item>
          </Descriptions>
        </div>

        {get(details, 'step3.product_government_compliance', []).length > 0 && (
          <>
            <div className="mt-40">
              <p className="normal-heading ">Product Goverment Complaince </p>
            </div>
            <div className="product-description-container ">
              <Table
                bordered
                size="small"
                pagination={false}
                dataSource={get(details, 'step3.meta.compliance', [])}
                columns={[
                  {
                    title: 'Sno.',
                    key: 'Sno',
                    render: (t, record, index) => `${index + 1}`,
                  },
                  {
                    title: 'Name',
                    key: 'name',
                    dataIndex: 'name',
                  },
                  {
                    title: 'Description',
                    dataIndex: 'description',
                    key: 'description',
                  },
                ]}
              />
            </div>
          </>
        )}

        {get(details, 'step3.product_property', []).length > 0 && (
          <>
            <div className="mt-40">
              <p className="normal-heading ">Product Property </p>
            </div>
            <div className="product-description-container ">
              <Table
                bordered
                size="small"
                pagination={false}
                dataSource={get(details, 'step3.meta.product_property', [])}
                columns={[
                  {
                    title: 'Sno.',
                    key: 'Sno',
                    render: (t, record, index) => `${index + 1}`,
                  },
                  {
                    title: 'Name',
                    key: 'name',
                    dataIndex: 'name',
                  },
                  {
                    title: 'Value',
                    dataIndex: 'value',
                    key: 'value',
                  },
                ]}
              />
            </div>
          </>
        )}

        {get(details, 'step4.other_info') && (
          <>
            <div className="mt-40">
              <p className="normal-heading ">Other Necessary Information </p>
            </div>
            <div className="product-description-container ">
              <Descriptions bordered column={1} size="small">
                <Descriptions.Item>
                  {get(details, 'step4.other_info')}
                </Descriptions.Item>
              </Descriptions>
            </div>
          </>
        )}

        <Row justify="center" className="mt-60">
          <Col xl={8}>
            <Button
              className="default-primary-btn"
              type="primary"
              icon={<ArrowLeftOutlined />}
              onClick={() => onMove(3)}
            >
              Back
            </Button>
          </Col>
          <Col xl={8} />
          <Col xl={8}>
            <Button
              className="default-primary-btn"
              type="primary"
              block
              onClick={() => {
                onSubmit();
              }}
            >
              Save & Proceed
            </Button>
          </Col>
        </Row>
        <Modal
          width="50%"
          destroyOnClose
          open={get(videoPreview, 'visible')}
          onOk={toggleVideoPreview}
          onCancel={toggleVideoPreview}
          footer={null}
          className="video-preview-modal"
        >
          {get(videoPreview, 'filePath')}
          <video width="100%" height="300" controls>
            <source src={get(videoPreview, 'filePath')} type="video/mp4" />
            <track
              src="captions_en.vtt"
              kind="captions"
              srcLang="en"
              label="english_captions"
            />
          </video>
        </Modal>
        <Modal
          visible={get(successModal, 'visible')}
          footer={null}
          closable={false}
        >
          <Result
            status="success"
            title={
              edit
                ? 'Product updated successfully'
                : 'Product created successfully'
            }
            subTitle={
              !edit && (
                <Space direction="vertical">
                  <p>Here is your Dhandha SKU code of product</p>
                  <Text copyable code>
                    {get(successModal, 'data.dhandha_sku')}
                  </Text>
                </Space>
              )
            }
            extra={[
              <Button
                className="default-primary-btn"
                type="primary"
                key="console"
                onClick={() => onClickGoToCataLogue()}
              >
                Back to Catalogue
              </Button>,
            ]}
          />
        </Modal>
      </div>
    </Spin>
  );
};

export default ProductFinalDetails;
